import type { RichAcl } from "@eu.mdotm.api/smart-workspaces";
import type { TableColumn } from "@mdotm/shadcn/legacy/components";
import { type UserListEntryProps, UsersList } from "./UsersList";
import { type MaybeFn, maybeCall } from "@mdotm/shadcn/legacy/utils";

export function sharingWithColumn<TRow extends { richAcl?: RichAcl }>(params: {
	users: MaybeFn<UserListEntryProps[], [TRow]>;
}): TableColumn<TRow, "sharingViews"> {
	return {
		content: (row, props) => {
			return <UsersList {...props} users={maybeCall(params.users, row)} visibleSlots={3} size="small" />;
		},
		sortFn: (a, b) => (a.richAcl?.acl?.length ?? 0) - (b.richAcl?.acl?.length ?? 0),
		name: "sharingViews",
		header: "Sharing with",
		width: 192,
	};
}
